import { Button, Modal } from "react-bootstrap";

import PreviewImageTab from './PreviewImageTab.scss';
import "../../css/Popup.scss";

const previewImageTab = ({
        modalData,
        show,
        setIsModalOpen
    }) => {
        // console.log(modalData, 'modalData')
        let localTabDetails;
        let modalImage;
        if(modalData && !modalData.imageName) {
            const localTabFileName = modalData?.substring(modalData.lastIndexOf('/') + 1);
            localTabDetails = localTabFileName.substring(0, localTabFileName.lastIndexOf('.')).replace(/\s+/g, '_');
            modalImage = modalData;
        } else {
            localTabDetails = modalData?.imageName;
            modalImage = modalData?.imageProductionLink;
        }

    return (
        <>
            <Modal
                show={show}
                size="lg"
                centered
                className="image-tab-modal"
            >   
                <Modal.Header className="image-tab-modal-header">
                     <Modal.Title 
                        className={`image-tab-modal-header-title ${Object.keys(localTabDetails).length > 21 
                        ? 'longer-title' 
                        : ''}`}
                        data-title={Object.keys(localTabDetails).length > 21 ? 
                            localTabDetails : ""}
                        >{localTabDetails}
                    </Modal.Title>
	            </Modal.Header>
                <Modal.Body className="image-tab-modal-body">
                    <img src={modalImage} className="img-fluid preview-modal-image"/>
                </Modal.Body>
                <div className="popupFooter">
                    <div className="popupFooterSeparator"></div>
                    <Button
                        className="btn popupFooterActiveButton"
                        type="button"
                        onClick={() => setIsModalOpen(false)}
                    >
                        CLOSE
                    </Button>
                </div>
            </Modal>
        </>
    )
}

export default previewImageTab;